/* src/app/pages/new-analysis/qpcr-report/qpcr-report.component.scss */
.mat-mdc-form-field + .mat-mdc-form-field {
  margin-left: 8px;
}
.mat-mdc-form-field {
  --mat-mdc-form-field-floating-label-scale: 0.75;
  display: block;
  flex-direction: column;
  min-width: 0;
  text-align: left;
}
::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: white;
}
::ng-deep label.mdc-label {
  margin-bottom: 0px;
}
.inputbox {
  float: right;
  position: absolute;
}
.expan-panel {
  position: relative;
  display: block;
}
label {
  display: inline-block;
  margin-right: 10px;
}
.table-display {
  margin-bottom: 10px;
}
.fa-info-circle {
  position: absolute;
}
.error-message {
  color: red;
  font-size: 12px;
  margin-top: 5px;
}
.mat-form-field-wrapper {
  padding-bottom: 0px !important;
}
.mat-error {
  margin-top: -2px;
  font-size: 12px;
  line-height: 1.2;
}
.radio-label {
  width: 368px;
  font-weight: 500;
  margin-right: 12px;
  margin-bottom: 0px;
}
.radio-group-row {
  margin-bottom: 12px;
}
.radio-option {
  margin-right: 44px;
  margin-bottom: 0px;
}
/*# sourceMappingURL=qpcr-report.component.css.map */
